export const PROMO_CODE_PRE = 'PANCREDPRE'
export const PROMO_CODE_POS = 'PANCREDPOS'